// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.controller {
  cursor: pointer;
  font-size: larger;
  font-family: 'Font Awesome';
  color: lightslategray;
}

.controller > i {
  margin: 0 0.25em;
}

.label > span {
  margin-inline: 0 0.5em;
}

.label > .inactive {
  color: lightgrey;
}
`, "",{"version":3,"sources":["webpack://./src/components/TransitionComponent/style.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".controller {\n  cursor: pointer;\n  font-size: larger;\n  font-family: 'Font Awesome';\n  color: lightslategray;\n}\n\n.controller > i {\n  margin: 0 0.25em;\n}\n\n.label > span {\n  margin-inline: 0 0.5em;\n}\n\n.label > .inactive {\n  color: lightgrey;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"controller": `controller`,
	"label": `label`,
	"inactive": `inactive`
};
export default ___CSS_LOADER_EXPORT___;
